import React, { useState,useEffect, useMemo } from "react";
import { Link, useNavigate,useParams } from 'react-router-dom'
import axios from "axios";
import {jobscategorycreate} from '../../../apis/urls'
import {schoolJobsurl} from '../../../apis/urls'
import moment from 'moment'
import { RichTextEditor } from '@mantine/rte';
import RteComponent from "./jobRte";





const EditJobComponent = () =>{

    const { id, jobid } = useParams();

    
    useEffect(() => {
        editlisting();
        JobCatListing();
    },[]
    );


    

    const modules = useMemo(
        () => ({
          history: { delay: 2500, userOnly: true },
          syntax: true,
        }),
        []
      );

    const [result,setResult] = useState([]);
    const [res,setRes] = useState([]);
    const [title,setTitle] = useState('');
    const [description,setDescription] = useState(null);
    const [expires_on,setExpires_on] = useState('');
    const [exp,setExp] = useState('');
    const [contact_name,setContact_name] = useState('');
    const [contact_email,setContact_email] = useState('');
    const [job_category_id,setJob_category_id] = useState('');
    const [status,setStatus] = useState('');


    const descriprionset = (text) =>{
        //console.log(text)
 
        
        setDescription(text)
    }

    useEffect(() => {
        //alert(description)
    },[description]
    );

    let navigate = useNavigate();
    const RoutToList = (id) =>{

        let path = 'newPath'; 
        navigate("/jobs/"+id)
        
    }

    const JobCatListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: jobscategorycreate+'?page='+0+'&size='+200,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data.items);
            console.log(response.data.data);
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

    const editlisting = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolJobsurl+'/'+id+'/'+jobid,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            setRes(response.data.data);
            //console.log("name",res)
            setTitle(response.data.data.title);
            setDescription(response.data.data.description);
            setExpires_on(response.data.data.expires_on);
            setContact_name(response.data.data.contact_name);
            setContact_email(response.data.data.contact_email);
            setJob_category_id(response.data.data.job_category_id);
            setStatus(response.data.data.status);
            // console.log('dec',description)
            }).catch((error) =>{
            console.log('error',error.message)
            });
    }



    const onEditForm = (id,jobid) => {

        let token = "Bearer "+localStorage.getItem('token');

        
        const data = {
            title :title,
            description :description,
            expires_on:moment(expires_on).format('MM-DD-YYYY'),
            contact_name:contact_name,
            contact_email:contact_email,
            job_category_id:job_category_id,
            school_id:id,
            status :status
        }
        
        const instance = axios.create({
            baseURL: schoolJobsurl+'/'+id+'/'+jobid,
            timeout: 1000000,
            headers: {'authorization': token}
          });
          
          instance.put('',data).then((response) =>{
            navigate("/jobs/"+id)
          }).catch((error) =>{
            console.log('error',error.message)
          });
    }

    //const Desc = "<p>Test by Thasleema solminds technologies carnival infopark, cochin , kerala, india , testing desciption</p>"

    return(
<div className="wrapper">
            <aside className="right-side ">
            <div className="content-area">  
            <div className="page-title-wrpr">
                <div className="page-title-left-column"> 
                    <h2 className="page-title">Edit Jobs</h2>
                </div>
                <div className="page-rightside-action-column">               
                </div>  
            </div>
        
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to={"/jobs/"+id}>Jobs</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Edit Jobs</li>
              </ol>
            </nav>  
            <div className="form-wrpr">
                <div className="card formcard small">
                    <div className="card-body">
                        <div className="form-group">
                            <label className="degreehead">Enter the job title</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={res.title} onChange={e => {setTitle(e.target.value)}} placeholder="Enter Faculty Name" id="name"></input>
                        </div>
                        <div className="form-group">
                            <RteComponent setdescription={setDescription} description={description} />                            
                        </div>

                        <div className="form-group">
                            <label className="degreehead">Expires ON</label>
                            <input type="date" className="form-control bg-dark dark-theme showtext" defaultValue={res.expires_on}  onChange={e => { setExpires_on(e.target.value) }} id="name"></input>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Contact Name</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={res.contact_name} onChange={e => {setContact_name(e.target.value)}} id="name"></input>
                        </div>

                        <div className="form-group">
                            <label className="degreehead">Contact Email</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={res.contact_email} onChange={e => {setContact_email(e.target.value)}} id="name"></input>
                        </div>
                        
                        <div className="form-group">
                            <label className="degreehead">Job Category</label>
                            <select className="form-control bg-dark dark-theme showtext" onChange={e => {setJob_category_id(e.target.value)}} id="status-selector">
                                <option value="0">Select Job Category</option>
                                {
                                    result?.map((item,index)=>(
                                        
                                        <option key={index} value={item.id} selected = {item.id === res.job_category_id }>{item.name}</option>
                                        
                                    )
                                    
                                    )
                                }
                             
                            </select>
                        </div>

                        <div className="form-group">
                                        <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                                        <select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
                                        <option value="ACTIVE">Select Status</option>
                                        <option value="ACTIVE" selected = {res.status === 'ACTIVE'}>ACTIVE</option>
                                        <option value="INACTIVE" selected = {res.status === 'INACTIVE'}>INACTIVE</option>
                                        <option value="DELETED" selected = {res.status === 'DELETED'}>DELETED</option>
                                        </select>                        
                                    </div>
                        
                        <div className="form-group text-right">
                        <button className="btn btn-danger btn-gisa" onClick={()=> { RoutToList(id)} } type="submit">Cancel</button>
                            <button onClick={()=>{ onEditForm(id,jobid) }} className="btn btn-primary btn-gisa" type="button">Edit Jobs</button>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
            </aside>
        </div>
    )
}

export default EditJobComponent;

